import React, { Component } from 'react';

import {
  FacebookShareButton,
  FacebookIcon,
  GooglePlusShareButton,
  GooglePlusIcon,
  TwitterShareButton,
  TwitterIcon,
  TelegramShareButton,
  TelegramIcon,
  WhatsappShareButton,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon,
} from 'react-share';

const size = 35;

class Share extends Component {
  render() {
    const shareUrl = 'http://especiales.diariodecadiz.es/infografia/2018/enfoque/humanidades/index.html';
    const title = 'Bárbaros, enfoque de domingo';

    return (
      <div>
        <h5 style={{ fontWeight: 100, textAlign: 'center', textTransform: 'uppercase', fontSize: '.9em', letterSpacing: '2px', margin: 0, padding: 0 }}>Comparte</h5>
        <div style={{ display: 'flex', justifyContent: 'space-between', paddingTop: '2em' }} className="sharer">
          <div>
            <FacebookShareButton url={shareUrl} quote={title}>
              <FacebookIcon size={size} round />
            </FacebookShareButton>
          </div>

          <div>
            <TwitterShareButton url={shareUrl} title={title}>
              <TwitterIcon size={size} round />
            </TwitterShareButton>
          </div>

          <div>
            <WhatsappShareButton url={shareUrl} title={title} separator=":: ">
              <WhatsappIcon size={size} round />
            </WhatsappShareButton>
          </div>

          <div>
            <TelegramShareButton url={shareUrl} title={title}>
              <TelegramIcon size={size} round />
            </TelegramShareButton>
          </div>

          <div>
            <GooglePlusShareButton url={shareUrl}>
              <GooglePlusIcon size={size} round />
            </GooglePlusShareButton>
          </div>

          <div>
            <EmailShareButton url={shareUrl} subject={title} body="body">
              <EmailIcon size={size} round />
            </EmailShareButton>
          </div>
        </div>
      </div>
    );
  }
}

export default Share;



// WEBPACK FOOTER //
// ./src/components/Sharer.js